import { useEffect } from "react";
import { useCookieConsent } from "@/context/CookieConsentContext";

/** Must match the Google tag in public/index.html */
const GA_MEASUREMENT_ID = "G-6J3QG1H26S";

/**
 * Syncs cookie consent with the Google tag already in <head>.
 * Does NOT inject a second gtag (Google forbids duplicate tags).
 */
export default function GoogleAnalytics() {
  const { hasConsent, consent } = useCookieConsent();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;

    const granted = hasConsent("statistics");
    window.gtag("consent", "update", {
      analytics_storage: granted ? "granted" : "denied",
      ad_storage: hasConsent("marketing") ? "granted" : "denied",
      ad_user_data: hasConsent("marketing") ? "granted" : "denied",
      ad_personalization: hasConsent("marketing") ? "granted" : "denied",
    });

    if (granted) {
      window.gtag("event", "page_view", {
        send_to: GA_MEASUREMENT_ID,
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
      });
    }
  }, [hasConsent, consent]);

  return null;
}
